import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FilterComponentDef } from '@df/catalog-ui/listing/filter/filter.component.def';
import { Model } from '@df/catalog/model';
import { surviveTreeShaking } from '@df/ng/survive-tree-shaking';
import { FilterPrimaryTag } from './filter-primary-tag';

surviveTreeShaking(FilterPrimaryTag);

@Component({
    selector: 'filter-primary-tag',
    templateUrl: './filter-primary-tag.html',
    standalone: true,
    imports: [CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterPrimaryTagComponent<T extends Model> extends FilterComponentDef<T> {
    @Input({ required: true })
    override filter!: FilterPrimaryTag<T>;

    @Input()
    primaryTag?: string;
}
